module.exports = __webpack_public_path__ + "static/img/logojc.36bb5e0f.png";